<template>
    <div class="row h-100 justify-content-center align-items-center bg-warning text-light">
        <div class="col-sm-8 col-11" v-if="project">
            <h1>Proyecto</h1>

            <div class="form-group mt-4">
                <label for="project_nombre">¿En que axis impactará?</label>

                <div class="text-left">
                    <div class="custom-control custom-checkbox" v-for="choice in choices" :key="choice">
                        <input
                            type="checkbox"
                            :value="choice"
                            :id="`check-` + choice"
                            v-model="project.axis"
                            class="custom-control-input"
                        />

                        <label class="custom-control-label" :for="`check-` + choice">{{ choice }}</label>
                    </div>
                </div>
                <!-- <input
                    v-if="project.axis.includes('Otros')"
                    type="text"
                    class="form-control"
                    v-model="project.axis_otros"
                /> -->
            </div>

            <button class="btn w-100 btn-light btn-lg mt-4" :disabled="disabled" @click="set">Siguiente</button>
        </div>
    </div>
</template>

<script>
import router from "../router";
import { mapActions, mapGetters } from "vuex";
export default {
    data() {
        return {
            project: null,
            choices: ["Delivery", "Marketing", "Productos", "Ventas", "Otros"],
            ...mapGetters(["getProject"]),
        };
    },
    mounted() {
        this.project = this.getProject();
    },
    computed: {
        axisOtros: function () {
            return this.project.axis.includes("Otros") && this.project.axisOtros;
        },
        disabled: function () {
            return this.project.axis.length == 0;
        },
    },
    methods: {
        set() {
            this.setProject(this.project);
            router.push("Project4");
        },
        ...mapActions(["setProject"]),
    },
};
</script>
